module.exports = __webpack_public_path__ + "static/media/Culturebie.1632e9a9.png";